// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path
				d="M14.5454545,1.71111111 L13.4545455,1.71111111 C13.2537146,1.71111111 13.0909091,
					1.87029876 13.0909091,2.06666667 L13.0909091,3.13333333 C13.0909091,3.91880498
					12.4396869,4.55555556 11.6363636,4.55555556 C10.8330404,4.55555556 10.1818182,
					3.91880498 10.1818182,3.13333333 L10.1818182,2.06666667 C10.1818182,1.87029876
					10.0190126,1.71111111 9.81818182,1.71111111 L6.18181818,1.71111111 C5.98098736,
					1.71111111 5.81818182,1.87029876 5.81818182,2.06666667 L5.81818182,3.13333333
					C5.81818182,3.91880498 5.16695964,4.55555556 4.36363636,4.55555556 C3.56031309,
					4.55555556 2.90909091,3.91880498 2.90909091,3.13333333 L2.90909091,2.06666667
					C2.90909091,1.87029876 2.74628536,1.71111111 2.54545455,1.71111111 L1.45454545,
					1.71111111 C0.651222182,1.71111111 0,2.34786169 0,3.13333333 L0,14.5111111 C0,
					15.2965828 0.651222182,15.9333333 1.45454545,15.9333333 L14.5454545,15.9333333
					C15.3487778,15.9333333 16,15.2965828 16,14.5111111 L16,3.13333333 C16,
					2.34786169 15.3487778,1.71111111 14.5454545,1.71111111 Z M14.5454545,
					14.1235556 C14.5534737,14.3283956 14.3912275,14.5013139 14.1818182,
					14.5111111 L1.81818182,14.5111111 C1.60877245,14.5013139 1.44652632,
					14.3283956 1.45454545,14.1235556 L1.45454545,6.36533333 C1.44652632,
					6.16049327 1.60877245,5.98757495 1.81818182,5.97777778 L14.1818182,
					5.97777778 C14.3912275,5.98757495 14.5534737,6.16049327 14.5454545,
					6.36533333 L14.5454545,14.1235556 Z M4.36363636,3.84444444 C4.76480068,
					3.84327296 5.08971098,3.52558289 5.09090909,3.13333333 L5.09090909,
					1.71111111 C5.09090909,1.31837529 4.765298,1 4.36363636,1 C3.96197473,
					1 3.63636364,1.31837529 3.63636364,1.71111111 L3.63636364,3.13333333
					C3.63756175,3.52558289 3.96247205,3.84327296 4.36363636,3.84444444
					Z M11.6363636,3.84444444 C12.037528,3.84327296 12.3624383,3.52558289
					12.3636364,3.13333333 L12.3636364,1.71111111 C12.3636364,1.31837529
					12.0380253,1 11.6363636,1 C11.234702,1 10.9090909,1.31837529 10.9090909,
					1.71111111 L10.9090909,3.13333333 C10.910289,3.52558289 11.2351993,
					3.84327296 11.6363636,3.84444444 Z"
				fillRule="nonzero"
			/>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Calendar.js